import { Heap } from './evercommerce';

interface HeapEventData {
  event: Parameters<Heap['track']>[0];
  properties: Parameters<Heap['track']>[1];
}

let eventQueue: HeapEventData[] = [];

// Watch for when heap loads. When it's ready, use it and also track queued events.
let retry = 0;
let timer: ReturnType<typeof setInterval> | undefined = undefined;

/**
 * If Heap is loaded, track a Heap event. Otherwise, add it
 * to a queue of events to be tracked once Heap is loaded.
 */
export function trackHeapEvent(
  ...[event, properties]: Parameters<Heap['track']>
): void {
  if (window.heap) {
    window.heap.track(event, properties);
    return;
  }

  eventQueue.push({ event, properties });
  // The first time we try to track an event and Heap doesn't exist,
  // start looking for when Heap is loaded
  if (typeof timer === 'undefined') {
    timer = setInterval(() => {
      if (window?.heap) {
        trackEventsInQueue(window.heap);
        clearInterval(timer);
        return;
      }
      retry++;
      if (retry >= 5) {
        clearInterval(timer);
      }
    }, 1000);
  }
}

/**
 * Track all events in the event queue, then clear it.
 */
const trackEventsInQueue = (heap: Heap) => {
  for (const { event, properties } of eventQueue) {
    heap.track(event, properties);
  }

  // Clear queue after tracking everything
  eventQueue = [];
};
